import React, { forwardRef } from 'react';

// Constants
import ToolbarConfig from '../../Toolbar/toolbar.config';

// Components
import Control from '../Control/Control';

type Props = {
  block: string;
  isGifPickerOpen?: boolean;
  handleGifPickerDropdownChange?: Function;
};

type ForwardedRef = {
  current: HTMLButtonElement;
};

const Gif = forwardRef(({ block, isGifPickerOpen, handleGifPickerDropdownChange }: Props, ref: ForwardedRef) => {
  const config = ToolbarConfig.find(item => item.block === block);

  const handleClick = () => {
    handleGifPickerDropdownChange();
  };

  return (
    <Control
      key={config.style}
      icon={config.icon}
      iconPrefix={config.iconPrefix}
      onClick={handleClick}
      ref={ref}
      active={isGifPickerOpen}
    />
  );
});

export default Gif;
